import { render } from "./LoginView.vue?vue&type=template&id=5cb608d6&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=5cb608d6&scoped=true&lang=css"

import exportComponent from "D:\\weixin_repair\\ideamerry_open_repair_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb608d6"]])

export default __exports__